<template>
  <section id="section-confirm-meeting" class="section-booking-calendar div-center">
    <h2>Confirmed</h2>
    <v-col cols="auto" style="width: 230px; margin-left: auto; margin-right: auto;">
      <v-select
          outlined
          label="Add to you calendar"
          :items="outCalendars"
          item-text="banner"
          item-value="val"
          v-model="selectCalendar"
          dense
          hide-details
          hide-selected
          menu-props="offset-y"
      ></v-select>
    </v-col>
    <div id="block-confirmed-data" class="top-border-center div-center">
      <meeting-details/>
    </div>
  </section>
</template>

<script>
import meetingDetails from "./meetingDetails";
import moment from 'moment-timezone';
import axios from "axios";
import QS from "qs";
import xlooLib from "../xlooLib/xlooLib";

export default {
  name: "confirmMeeting",
  // eslint-disable-next-line vue/no-unused-components
  components: { meetingDetails, xlooLib },
  data(){
    return {
      outCalendars: [{val: 'other', banner: 'Other'}, {val: 'google', banner: 'Google'}, { val: 'outlook', banner: 'Outlook'},  ],
      selectCalendar: 'none',
      dataMeeting: null,
    }
  },
  watch : {
    selectCalendar(val){
      if (val === 'google') this.googleLink();
      if( val === 'outlook' || val === 'other') this.outLookLink();
    }
  },
  created: function() {
    this.dataMeeting = xlooLib.dateOfTimeZone(
        moment(this.$store.getters.dateBooking).format('YYYY'),
        moment(this.$store.getters.dateBooking).format('MM'),
        moment(this.$store.getters.dateBooking).format('DD'),
        moment(this.$store.getters.dateBooking).format('HH:mm'),
        this.$store.getters.timeZoneLead
    )
  },
  methods:{
    googleLink(){
      const nameBanner = '+' + this.createBannerMeetingDuration() + ' Meeting with ' + this.$store.getters.firstNameUser + ' ' + this.$store.getters.lastNameUser;
      const timeBanner = '+' + moment(this.$store.getters.dateBooking).format('HH:mm') + '-' +
          moment(this.$store.getters.dateBooking).add(this.$store.getters.meetingDuration, 'm').format('HH:mm') + '+' +
          '(' + this.$store.getters.timeZoneLeadBanner + ')' +
          '+on+' + moment(this.$store.getters.dateBooking).format('dddd') + ',+' +
          moment(this.$store.getters.dateBooking).format('MMMM') + '+' +
          moment(this.$store.getters.dateBooking).format('DD') + ',+' +
          moment(this.$store.getters.dateBooking).format('YYYY');
      // eslint-disable-next-line no-unused-vars
      const linkGoogle = 'https://calendar.google.com/calendar/u/0/r/eventedit?text=' + nameBanner +
        '&dates=' + moment.utc(this.dataMeeting).format('YYYY') +
        moment.utc(this.dataMeeting).format('MM') +
        moment.utc(this.dataMeeting).format('DD') +
        'T' + moment.utc(this.dataMeeting).format('HH') +
        moment.utc(this.dataMeeting).format('mm') +
        '00Z' +
        '/' + moment.utc(this.dataMeeting).add(this.$store.getters.meetingDuration,'m').format('YYYY') +
          moment.utc(this.dataMeeting).add(this.$store.getters.meetingDuration,'m').format('MM') +
          moment.utc(this.dataMeeting).add(this.$store.getters.meetingDuration,'m').format('DD') +
        'T' + moment.utc(this.dataMeeting).add(this.$store.getters.meetingDuration,'m').format('HH') +
          moment.utc(this.dataMeeting).add(this.$store.getters.meetingDuration,'m').format('mm') +
        '00Z' +
        '&details=Event+Name:' + nameBanner +
        '+Time:' + timeBanner;
/*
      'dates=' + moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).format('YYYY') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).format('MM') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).format('DD') +
          'T' + moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).format('HH') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).format('mm') +
          '00Z' +
      '/' + moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,'m').format('YYYY') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,'m').format('MM') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,'m').format('DD') +
          'T' + moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,'m').format('HH') +
          moment(this.$store.getters.dateBooking).utc().utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,'m').format('mm') +
          '00Z' +
      '&details=Event+Name:' + nameBanner +
      '+Time:' + timeBanner;

 */
      window.open(linkGoogle);
    },
    async outLookLink(){
      const requestPath = '/index.php';
      const dataRequest = {
        entryPoint: 'booking',
        action: 'download',
        startDate: moment.utc(this.$store.getters.dateBooking).format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment.utc(this.$store.getters.dateBooking).add(this.$store.getters.meetingDuration, 'm').format('YYYY-MM-DD HH:mm:ss'),
        timeZone: this.$store.getters.timeZoneLead,
        description: this.$store.getters.descriptionMeeting,
        summary: this.createBannerMeetingDuration() + ' meeting with ' + this.$store.getters.firstNameUser + ' ' + this.$store.getters.lastNameUser,
      }
      try {
        const resOutLink = await axios.post(requestPath, QS.stringify(dataRequest));

        const url = window.URL.createObjectURL(new Blob([resOutLink.data.content]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'outlook_calendar_booking_calendar.ics'); //or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log('error', e);
        throw e
      }

    },
    createBannerMeetingDuration(){
      let banner = "";
      const hours = Math.trunc(this.$store.getters.meetingDuration/60);
      const minutes = this.$store.getters.meetingDuration - 60*hours;
      if(hours>1) banner = hours + " Hours";
      else if(hours===1) banner = hours + " Hour";
      if(minutes>1) banner = banner + minutes + " Minutes";
      else if(minutes===1) banner = banner + minutes + " Minute";
      return banner;
    },
  }
}
</script>

<style scoped>
  #section-confirm-meeting{
    max-width: 600px;
  }
  #block-confirmed-data{
    width: fit-content;
  }
</style>